import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions/global.actions';

import { COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE } from '../actions';

const initialState = {
  config: { loading: false, error: null, data: null },
  subCompanyConfig: { loading: false, error: null, data: null },
  allSubCompaniesConfig: { loading: false, error: null, data: null },
};

const commandCenterPageConfigReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.LOAD_CONFIG_REQUEST:
        draft.config.loading = true;
        draft.config.error = null;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.LOAD_CONFIG_SUCCESS:
        draft.config.loading = false;
        draft.config.error = null;
        draft.config.data = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.LOAD_CONFIG_FAILURE:
        draft.config.loading = false;
        draft.config.error = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.UPDATE_CONFIG_REQUEST:
        draft.config.loading = true;
        draft.config.error = null;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.UPDATE_CONFIG_SUCCESS:
        draft.config.loading = false;
        draft.config.error = null;
        draft.config.data = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.UPDATE_CONFIG_FAILURE:
        draft.config.loading = false;
        draft.config.error = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.LOAD_SUB_COMPANY_CONFIG_REQUEST:
        draft.subCompanyConfig.loading = true;
        draft.subCompanyConfig.error = null;
        draft.subCompanyConfig.data = null;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.LOAD_SUB_COMPANY_CONFIG_SUCCESS:
        draft.subCompanyConfig.loading = false;
        draft.subCompanyConfig.error = null;
        draft.subCompanyConfig.data = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.LOAD_SUB_COMPANY_CONFIG_FAILURE:
        draft.subCompanyConfig.loading = false;
        draft.subCompanyConfig.error = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.UPDATE_SUB_COMPANY_CONFIG_REQUEST:
        draft.subCompanyConfig.loading = true;
        draft.subCompanyConfig.error = null;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.UPDATE_SUB_COMPANY_CONFIG_SUCCESS:
        draft.subCompanyConfig.loading = false;
        draft.subCompanyConfig.error = null;
        draft.subCompanyConfig.data = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.UPDATE_SUB_COMPANY_CONFIG_FAILURE:
        draft.subCompanyConfig.loading = false;
        draft.subCompanyConfig.error = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.LOAD_ALL_SUBCOMPANIES_CONFIG_REQUEST:
        draft.allSubCompaniesConfig.loading = true;
        draft.allSubCompaniesConfig.error = null;
        draft.allSubCompaniesConfig.data = null;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.LOAD_ALL_SUBCOMPANIES_CONFIG_SUCCESS:
        draft.allSubCompaniesConfig.loading = false;
        draft.allSubCompaniesConfig.error = null;
        draft.allSubCompaniesConfig.data = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.LOAD_ALL_SUBCOMPANIES_CONFIG_FAILURE:
        draft.allSubCompaniesConfig.loading = false;
        draft.allSubCompaniesConfig.error = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.UPDATE_ALL_SUBCOMPANIES_CONFIG_REQUEST:
        draft.allSubCompaniesConfig.loading = true;
        draft.allSubCompaniesConfig.error = null;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.UPDATE_ALL_SUBCOMPANIES_CONFIG_SUCCESS:
        draft.allSubCompaniesConfig.loading = false;
        draft.allSubCompaniesConfig.error = null;
        draft.allSubCompaniesConfig.data = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.UPDATE_ALL_SUBCOMPANIES_CONFIG_FAILURE:
        draft.allSubCompaniesConfig.loading = false;
        draft.allSubCompaniesConfig.error = payload;
        break;

      case COMMAND_CENTER_PAGE_CONFIG_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default commandCenterPageConfigReducer;
